import { Pipe, PipeTransform } from "@angular/core";
import { parsePhoneNumber } from "libphonenumber-js";
@Pipe({
    name: "phonenumberformatter",
})
export class PhoneNumberFormatterPipe implements PipeTransform {
    transform(phoneNumber: string) {
        if (!phoneNumber) return phoneNumber;
        try {
            const pn = parsePhoneNumber(phoneNumber);
            if (pn.isValid()) {
                return pn.formatInternational();
            } else {
                return phoneNumber;
            }
        } catch (err) {
            return phoneNumber;
        }
    }
}
